<div *ngIf="tools.includes(ImageActionType.TextToImage)" class="group mt-3 mb-3">

	<!-- Fallback Mode UI -->
	<ng-container *ngIf="isFallbackMode && textToImageForm">
		<app-select-input
			class="block mb-3"
			label="Model"
			i18n-label="Model@@imageToolImageGenerationModelLabel"
			[options]="availableModels"
			[parentForm]="textToImageForm"
			controlName="model"
		></app-select-input>

		<app-textarea-input
			class="block mb-3"
			label="Text to image Prompt"
			i18n-label="Text to image Prompt@@imageToolImageGenerationTextToImagePromptLabel"
			placeholder="Enter a prompt of what you want to generate."
			i18n-placeholder="Text to image Prompt Placeholder@@imageToolImageGenerationTextToImagePromptPlaceholder"
			[parentForm]="textToImageForm"
			[controlName]="'prompt'"
		></app-textarea-input>

		<app-select-input
			class="block mb-3"
			label="Aspect Ratio"
			i18n-label="Aspect Ratio@@imageToolImageGenerationAspectRatioLabel"
			[options]="defaultAspectRatios"
			[parentForm]="textToImageForm"
			[controlName]="'aspectRatio'"
		></app-select-input>

		<app-range-input
			class="block mb-3"
			[label]="'Number of Images (' + (textToImageForm.get('numberOfResults')?.value || 1) + ')'"
			i18n-label="Number of Images@@imageToolImageGenerationNumberOfImagesLabel"
			[min]="1"
			[max]="4"
			[step]="1"
			[parentForm]="textToImageForm"
			[controlName]="'numberOfResults'"
		></app-range-input>

		<!-- Reference Images Section (only shown if model supports it) -->
		<div class="mb-3" *ngIf="selectedModelSupportsReferenceImages">
			<button
				mat-stroked-button
				color="primary"
				(click)="openReferenceImagePicker()"
				[disabled]="isMaxReferenceImagesSelected"
				class="mb-2">
				<mat-icon>add_photo_alternate</mat-icon>
				<span i18n="Add Reference Images@@imageToolImageGenerationAddReferenceImages">Add Reference Images</span>
			</button>

			<!-- Reference Images Thumbnail Grid -->
			<div *ngIf="selectedReferenceImages.length > 0" class="reference-images-grid">
				<div *ngFor="let image of selectedReferenceImages; let i = index" class="reference-image-thumbnail">
					<img [src]="image.assetPath" [alt]="image.title" />
					<button
						mat-icon-button
						class="remove-button"
						(click)="removeReferenceImage(i)"
						[attr.aria-label]="'Remove image ' + (i + 1)">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>

			<small *ngIf="isMaxReferenceImagesSelected" class="max-images-message">
				<mat-icon class="small-icon">info</mat-icon>
				<span i18n="Maximum images selected@@imageToolImageGenerationMaxImagesSelected">Maximum 14 reference images selected</span>
			</small>
		</div>

		<!-- Advanced Settings Toggle -->
		<div class="mb-3">
			<small class="pointer" (click)="showAdvancedOptions = !showAdvancedOptions">
				<span *ngIf="showAdvancedOptions">Hide</span>
				<span *ngIf="!showAdvancedOptions">Show</span> Advanced Config
			</small>
		</div>

		<!-- Advanced Settings Section -->
		<div *ngIf="showAdvancedOptions" class="advanced-settings">
			<app-range-input
				class="block mb-3"
				label="Temperature"
				i18n-label="Temperature@@imageToolImageGenerationTemperatureLabel"
				[min]="0.0"
				[max]="2.0"
				[step]="0.1"
				[parentForm]="textToImageForm"
				[controlName]="'temperature'"
			></app-range-input>

			<app-range-input
				class="block mb-3"
				label="Top-P"
				i18n-label="Top-P@@imageToolImageGenerationTopPLabel"
				[min]="0.0"
				[max]="1.0"
				[step]="0.05"
				[parentForm]="textToImageForm"
				[controlName]="'topP'"
			></app-range-input>

			<app-text-input
				class="block mb-3"
				label="Seed (optional)"
				i18n-label="Seed@@imageToolImageGenerationSeedLabel"
				type="number"
				placeholder="Enter a seed for reproducible results"
				i18n-placeholder="Seed Placeholder@@imageToolImageGenerationSeedPlaceholder"
				[parentForm]="textToImageForm"
				[controlName]="'seed'"
			></app-text-input>

			<app-textarea-input
				class="block mb-3"
				label="Negative Prompt (optional)"
				i18n-label="Negative Prompt@@imageToolImageGenerationNegativePromptLabel"
				placeholder="Describe what you don't want in the image"
				i18n-placeholder="Negative Prompt Placeholder@@imageToolImageGenerationNegativePromptPlaceholder"
				[parentForm]="textToImageForm"
				[controlName]="'negativePrompt'"
			></app-textarea-input>
		</div>
	</ng-container>

	<!-- Original Data Source Mode UI -->
	<ng-container *ngIf="!isFallbackMode && config?.dataSource?.config?.models?.length">
		<app-select-input
			class="block mb-3"
			label="Model"
			i18n-label="Model@@imageToolImageGenerationModelLabel"
			[options]="config.dataSource.config.models"
			[parentForm]="textToImageForm"
			controlName="model"
		></app-select-input>
	</ng-container>

	<ng-container *ngIf="!isFallbackMode && textToImageForm">
		<app-textarea-input
			class="block mb-3"
			label="Text to image Prompt"
			i18n-label="Text to image Prompt@@imageToolImageGenerationTextToImagePromptLabel"
			placeholder="Enter a prompt of what you want to generate."
			i18n-placeholder="Text to image Prompt Placeholder@@imageToolImageGenerationTextToImagePromptPlaceholder"
			[parentForm]="textToImageForm"
			[controlName]="'prompt'"
		></app-textarea-input>

		<app-select-input
			*ngIf="textToImageForm.get('aspect_ratio')"
			class="block mb-3"
			label="Aspect Ratio"
			i18n-label="Aspect Ratio@@imageToolImageGenerationAspectRatioLabel"
			[options]="aspectRatios"
			[parentForm]="textToImageForm"
			[controlName]="'aspect_ratio'"
		></app-select-input>
	</ng-container>

	<button mat-flat-button class="block with-loading mt-3" color="primary" (click)="replaceBackground()" [disabled]="loadingAction === ImageActionType.TextToImage || !textToImageForm || textToImageForm.invalid">
		<span class="text" i18n="Generate Button@@imageToolImageGenerationGenerateButtonLabel">Generate</span>
		<span class="spinner"><mat-spinner diameter="20" color="accent"></mat-spinner></span>
	</button>
</div>
